import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { scroller } from "react-scroll";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
import Wings from "../components/Sections/Wings";
import UpcomingEvents from "../components/Sections/UpcomingEvents";
import Projects from "../components/Sections/Projects";
import Blog from "../components/Sections/Blog";
import Reviews from "../components/Sections/Reviews";
import Contact from "../components/Sections/Contact";
import AnimateOnScroll from "../components/AnimateOnScroll";
import Footer from "../components/Sections/Footer";
import FloatingChat from "../components/FloatingChat";

export default function Landing() {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://afriqcm.com';
  const currentUrl = typeof window !== 'undefined' ? window.location.href : siteUrl;

  // When opening /#section from another page, scroll to that section after mount
  useEffect(() => {
    const hash = typeof window !== "undefined" ? window.location.hash.slice(1) : "";
    if (!hash) return;
    const timer = setTimeout(() => {
      scroller.scrollTo(hash, { smooth: true, offset: -80 });
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Helmet>
        <html lang="en" />
        <link rel="canonical" href={currentUrl} />
        
        {/* Open Graph / Facebook - Ensure proper image for WhatsApp */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:title" content="AFRIQ Bamenda - Academic Foundation for Rising Intellectuals in Africa" />
        <meta property="og:description" content="Helping students study the right way, understand key concepts, and prepare effectively for competitive entrance exams through structured concours preparation, expert teaching, academic orientation, and career mentorship." />
        <meta property="og:image" content={`${siteUrl}/logo512.png`} />
        <meta property="og:image:secure_url" content={`${siteUrl}/logo512.png`} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />
        <meta property="og:image:alt" content="AFRIQ Bamenda Logo" />
        <meta property="og:site_name" content="AFRIQ Bamenda" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={currentUrl} />
        <meta name="twitter:title" content="AFRIQ Bamenda - Academic Foundation for Rising Intellectuals in Africa" />
        <meta name="twitter:description" content="Helping students study the right way, understand key concepts, and prepare effectively for competitive entrance exams." />
        <meta name="twitter:image" content={`${siteUrl}/logo512.png`} />
        <meta name="twitter:image:alt" content="AFRIQ Bamenda Logo" />
        
        {/* Structured Data - Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "EducationalOrganization",
            "name": "AFRIQ Bamenda",
            "alternateName": "Academic Foundation for Rising Intellectuals in Africa",
            "url": siteUrl,
            "logo": `${siteUrl}/logo512.png`,
            "description": "Academic Foundation for Rising Intellectuals in Africa - Helping students study the right way, understand key concepts, and prepare effectively for competitive entrance exams",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Bamenda",
              "addressRegion": "Northwest Region",
              "addressCountry": "CM"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+237-679235785",
              "contactType": "Customer Service",
              "email": "info@afriqcm.com"
            },
            "sameAs": [
              "https://www.facebook.com/afriqcm",
              "https://www.twitter.com/afriqcm",
              "https://www.instagram.com/afriqcm",
              "https://www.linkedin.com/company/afriqcm"
            ]
          })}
        </script>
        
        {/* Structured Data - WebSite Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "AFRIQ Bamenda",
            "url": siteUrl,
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": `${siteUrl}/blogs?search={search_term_string}`
              },
              "query-input": "required name=search_term_string"
            }
          })}
        </script>
      </Helmet>
      <TopNavbar />
      <Header />
      <AnimateOnScroll>
        <Wings />
      </AnimateOnScroll>
      <AnimateOnScroll>
        <UpcomingEvents />
      </AnimateOnScroll>
      <AnimateOnScroll>
        <Projects />
      </AnimateOnScroll>
      <AnimateOnScroll>
        <Blog />
      </AnimateOnScroll>
      <AnimateOnScroll>
        <Reviews />
      </AnimateOnScroll>
      <AnimateOnScroll>
        <Contact />
      </AnimateOnScroll>
      <Footer />
      <FloatingChat />
    </>
  );
}


